import { render, staticRenderFns } from "./Extractor.vue?vue&type=template&id=a32d467c&"
import script from "./Extractor.vue?vue&type=script&lang=js&"
export * from "./Extractor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports